import { mobile, notDesktop, styled } from '@obvio/app'
import { Button, Stack, Grid, GridItem } from '@obvio/ui'
import { motion } from 'framer-motion'

const Parallax = styled.div`
  height: 100%;
`

export const CenterButton = styled(Button)`
  display: block;
  margin: 0 auto;
  @media ${mobile} {
    margin-top: 3rem;
  }
`

export const CenterStack = styled(Stack)`
  align-items: center;
`

export const MotionParallax = motion(Parallax)
export const Fade = styled.div`
  height: 100%;
  max-width: 25rem;
  position: relative;
`

export const MotionFade = motion(Fade)

export const GridWrap = styled(Grid)`
  grid-auto-rows: 75px;

  @media ${notDesktop} {
    grid-template-columns: 1fr;
    grid-auto-rows: 26rem;
    grid-gap: ${(theme) => theme.spacing.extraLarge};
  }
`

export const Item = styled(GridItem)<{ $row: number }>`
  grid-row: ${(_, { $row }) => `${$row} / span 4`};
  @media ${notDesktop} {
    grid-column: 1;
    grid-row: span 1;
  }
`
